// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".editorDialog[data-v-648740a4]{width:100%}.editorDialog .dialog-footer[data-v-648740a4]{margin:0 0 0 100px}", ""]);
// Exports
module.exports = exports;
